import { createAction } from '@reduxjs/toolkit';

import {
    FilterValueSetPayload,
    IChangeFilterSelection,
    IFilterPayload,
    IGuidePayload,
    ISetFilterPayload,
    ISetFilterSubCategoryId,
    ISetGuide,
    ISetLoading,
    ISetPage,
    IToastPayload,
    IToggleCookiesDrawer,
    IToggleAccountModal,
    IToggleInterestModal,
    IToggleCreator,
    IToggleDrawer,
    IToggleNotification,
    TSwitch,
    types,
    IShareLinks,
    IGetFilter,
    IFilter,
    IGetForms,
    IRecommendation,
    TSignUpRoutes,
    ISaveFormDraft,
    ILoadFormDraft,
    IClearFormDraft,
    MessagesExpandedReturnTarget,
} from './types';
import { IErrorType } from '../../constants/types';
import { IRegistrationForm } from '../../types/global/forms.types';

export const setPage = createAction<ISetPage>(types.SET_PAGE);
export const setAppLoading = createAction<ISetLoading>(types.SET_APP_LOADING);
export const toggleDrawer = createAction<IToggleDrawer>(types.TOGGLE_APP_DRAWER);
export const setFilter = createAction<ISetFilterPayload>(types.SET_FILTER);
export const changeFilterSelection = createAction<IChangeFilterSelection>(types.CHANGE_FILTER_SELECTION);
export const setFilterSubCategory = createAction<FilterValueSetPayload>(types.SET_FILTER_SUB_SELECTION);
export const clearFilterSubCategory = createAction<{ id: number }>(types.CLEAR_FILTER_SUB_SELECTION);
export const clearFilter = createAction(types.CLEAR_FILTER);
export const toggleFiler = createAction<IFilterPayload>(types.TOGGLE_FILTER);
export const setFilterSubCategoryId = createAction<ISetFilterSubCategoryId>(types.SET_FILTER_SUB_CATEGORY);
export const toggleNotification = createAction<IToggleNotification>(types.TOGGLE_NOTIFICATION);
export const toggleAccountModal = createAction<IToggleAccountModal>(types.TOGGLE_ACCOUNT_MODAL);
export const toggleInterestModal = createAction<IToggleInterestModal>(types.TOGGLE_INTEREST_MODAL);
export const toggleCreatorModal = createAction<IToggleCreator>(types.TOGGLE_CREATOR_MODAL);
export const toggleCookiesModal = createAction<IToggleCookiesDrawer>(types.TOGGLE_COOKIES_DRAWER);
export const toggleToast = createAction<IToastPayload>(types.TOGGLE_TOAST);
export const setShowGuide = createAction<ISetGuide>(types.SET_SHOW_GUIDE);
export const setShowSearchBox = createAction<TSwitch>(types.SET_SHOW_SEARCH_BOX);

export const setGuideLink = createAction<IGuidePayload>(types.SET_GUIDE_LINK);
export const setShowProjectCreatorGuide = createAction<boolean>(types.SET_SHOW_PROJECT_CREATOR_GUIDE);
export const setUsersFirstProjectSuggestionBox = createAction<boolean>(types.SET_SHOW_PROJECT_SUGGESTION_BOX);

export const setShareModalStatus = createAction<IShareLinks>(types.SET_SHARE_MODAL_STATUS);

export const resetRedirect = createAction(types.RESET_REDIRECT);

export const setProjectGuide = createAction<boolean>(types.SET_PROJECT_GUIDE);
export const getProjectGuide = createAction(types.GET_PROJECT_GUIDE);

export const toggleTheme = createAction<'dark' | 'light'>(types.TOGGLE_THEME);

export const getFilters = createAction<IGetFilter>(types.GET_FILTERS);
export const getFiltersSuccess = createAction<IFilter>(types.GET_FILTERS_SUCCESS);
export const getFiltersFail = createAction<IErrorType>(types.GET_FILTERS_FAIL);

export const getSystemForms = createAction<IGetForms>(types.GET_SYSTEM_FORMS);
export const getSystemFormsSuccess = createAction<IRegistrationForm[]>(types.GET_SYSTEM_FORMS_SUCCESS);
export const getSystemFormsFail = createAction<IErrorType>(types.GET_SYSTEM_FORMS_FAIL);

export const setRecommendation = createAction<IRecommendation | undefined>(types.SET_RECOMMENDATION);

export const setSystemForm = createAction<string | undefined>(types.SET_SYSTEM_FORM);

export const toggleSubscriptionModal = createAction<import('./types').ToggleSubscriptionModalPayload | undefined>(
    types.TOGGLE_SUBSCRIPTION_MODAL,
);

export const toggleMessagenModal = createAction<boolean | undefined>(types.TOGGLE_MESSAGE_MODAL);

export const setSignUpRoute = createAction<TSignUpRoutes>(types.SET_SIGNUP_ROUTE);

export const toggleIsMessageModalExpanded = createAction<boolean | undefined>(types.TOGGLE_EXPAND_MESSAGE_MODAL);

export const toggleFloatingMessageModal = createAction<boolean | undefined>(types.TOGGLE_FLOATING_MESSAGE_MODAL);

export const toggleAvatarMessageModal = createAction<boolean | undefined>(types.TOGGLE_AVATAR_MESSAGE_MODAL);

export const setMessagesExpandedReturnTarget = createAction<MessagesExpandedReturnTarget | undefined>(
    types.SET_MESSAGES_EXPANDED_RETURN_TARGET,
);

export const closeEphemeralMessageUi = createAction(types.CLOSE_EPHEMERAL_MESSAGE_UI);

// Draft management actions
export const saveFormDraft = createAction<ISaveFormDraft>(types.SAVE_FORM_DRAFT);
export const loadFormDraft = createAction<ILoadFormDraft>(types.LOAD_FORM_DRAFT);
export const clearFormDraft = createAction<IClearFormDraft>(types.CLEAR_FORM_DRAFT);
export const clearAllDrafts = createAction(types.CLEAR_ALL_DRAFTS);
